import { ListControls } from '../types/list';

export function toQueryString({
  page,
  pageSize,
  search,
  sort,
}: ListControls): string {
  const params = new URLSearchParams();
  if (page != null) params.set('page', String(page));
  if (pageSize != null) params.set('pageSize', String(pageSize));
  if (typeof search === 'string' && search !== '') params.set('search', search);
  if (typeof sort === 'string' && sort !== '') params.set('sort', sort);
  return params.toString();
}

export function parseUrlParams(search: string): Record<string, string> {
  const params = new URLSearchParams(
    search.startsWith('?') ? search : `?${search}`
  );
  const result: Record<string, string> = {};
  params.forEach((value, key) => {
    result[key] = value;
  });
  return result;
}

export function stringifyUrlParams(obj: Record<string, any>): string {
  const usp = new URLSearchParams();
  Object.entries(obj).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      usp.set(key, String(value));
    }
  });
  return usp.toString();
}

export function parseSort(sort?: string | null): {
  field?: string;
  order?: 'ascend' | 'descend';
} {
  if (!sort) return {};
  const [field, order] = String(sort).split(':');
  if (!field || !order) return {};
  return {
    field,
    order:
      order === 'asc' ? 'ascend' : order === 'desc' ? 'descend' : undefined,
  };
}
